import React from "react";
import classes from "./index.module.css";

type Props = {};

const NoAccessPage = (props: Props) => {
	return (
		<div className={classes.mainContainer}>
			<div className={classes.firstContainer}>
				<h1 className={classes.title}>
					You dont have access to this page, contact your
					administrator
				</h1>
			</div>
		</div>
	);
};

export default NoAccessPage;
